import { render, staticRenderFns } from "./Feats.vue?vue&type=template&id=31def85c&"
import script from "./Feats.vue?vue&type=script&lang=js&"
export * from "./Feats.vue?vue&type=script&lang=js&"
import style0 from "./Feats.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports